import * as React from 'react';
import { useSelector } from 'react-redux';

import { AiBannerFloatingExpanded } from '../../components/AiBannerFloating';
import { SUMMARY_ENABLED_CONFIG_KEY } from '../../constants/summary';
import { selectAiSummaryEntryPoint } from '../../selectors/newbuildingsCompare';
import { useApplicationContext } from '../../utils/applicationContext';
import { trackClickAiBanner } from './tracking';

export interface IAiBannerFloatingContainerProps {
  visible: boolean;
  onOpen: () => void;
}

export const AiBannerFloatingContainer = ({
  visible,
  onOpen,
}: IAiBannerFloatingContainerProps): React.JSX.Element | null => {
  const aiSummaryEntryPoint = useSelector(selectAiSummaryEntryPoint);
  const { config } = useApplicationContext();
  const isAiSummaryEnabled = config.get<boolean>(SUMMARY_ENABLED_CONFIG_KEY);

  const handleOpen = React.useCallback(() => {
    trackClickAiBanner('desktop');
    onOpen();
  }, [onOpen]);

  if (!aiSummaryEntryPoint || !isAiSummaryEnabled) {
    return null;
  }

  return <AiBannerFloatingExpanded {...aiSummaryEntryPoint} onOpen={handleOpen} visible={visible} />;
};
